import { render, staticRenderFns } from "./h5Content.vue?vue&type=template&id=35c71f7c&scoped=true"
import script from "./h5Content.vue?vue&type=script&lang=js"
export * from "./h5Content.vue?vue&type=script&lang=js"
import style0 from "./h5Content.vue?vue&type=style&index=0&id=35c71f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c71f7c",
  null
  
)

export default component.exports